import React, { useState, useEffect } from 'react';

// Trust Ribbon - Top strip - Purple & Gold
export const TrustRibbon = () => {
 const trustPoints = [
 "❖ 25+ वर्षों का अनुभव",
 "50,000+ संतुष्ट भक्त",
 "97% सफलता दर",
 "क्षमतानुसार दक्षिणा",
 "100% गोपनीय"
 ];

 return (
 <div className="bg-gradient-to-r from-red-950 via-red-900 to-red-950 py-2 overflow-hidden" data-testid="trust-ribbon">
 <div className="flex animate-marquee whitespace-nowrap">
 {[...trustPoints, ...trustPoints].map((point, i) => (
 <span key={i} className="mx-6 text-[#F0DCA0] text-sm font-bold">{point}</span>
 ))}
 </div>
 <style>{`
 @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
 .animate-marquee { animation: marquee 20s linear infinite; }
 `}</style>
 </div>
 );
};

// Urgency Counter - REMOVED as per user request
export const UrgencyCounter = () => {
 return null;
};

// Live Notification Popup - Purple Theme
export const LiveNotificationPopup = () => {
 const [notification, setNotification] = useState(null);
 
 const notifications = [
 { name: "राजेश कुमार", city: "दिल्ली", problem: "वशीकरण" },
 { name: "सीमा देवी", city: "मुंबई", problem: "संतान प्राप्ति" },
 { name: "अमित शर्मा", city: "जयपुर", problem: "धन समस्या" },
 { name: "प्रिया सिंह", city: "लखनऊ", problem: "काला जादू" },
 { name: "विकास यादव", city: "पटना", problem: "विवाह" },
 ];

 useEffect(() => {
 const showNotification = () => {
 const randomNotif = notifications[Math.floor(Math.random() * notifications.length)];
 setNotification({ ...randomNotif, time: "अभी" });
 setTimeout(() => setNotification(null), 4000);
 };

 const interval = setInterval(showNotification, 15000);
 setTimeout(showNotification, 3000);
 return () => clearInterval(interval);
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 if (!notification) return null;

 return (
 <div className="fixed bottom-20 left-3 z-40 animate-slideIn" data-testid="live-notification">
 <div className="px-3 py-2 rounded-full flex items-center gap-2 max-w-[250px]" style={{ background: 'rgba(20,20,25,0.97)', border: '1px solid rgba(201,162,58,0.55)', boxShadow: '0 6px 20px rgba(0,0,0,0.55)', backdropFilter: 'blur(8px)' }}>
 <div className="w-7 h-7 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-black" style={{ background: 'linear-gradient(135deg, #5B1818, #7a2929)', color: '#F0DCA0' }}>
 {notification.name.charAt(0)}
 </div>
 <div className="min-w-0 leading-tight">
 <p className="text-[11px] font-bold truncate" style={{ color: '#F3EDE2' }}>{notification.name} · {notification.city}</p>
 <p className="text-[10px] truncate" style={{ color: '#A8A199' }}>
 <span className="inline-block w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse mr-1"></span>
 {notification.problem} के लिए संपर्क किया · अभी
 </p>
 </div>
 </div>
 <style>{`
 @keyframes slideIn { 0% { transform: translateX(-110%); opacity: 0; } 100% { transform: translateX(0); opacity: 1; } }
 .animate-slideIn { animation: slideIn 0.45s cubic-bezier(.22,1,.36,1); }
 `}</style>
 </div>
 );
};

// Aggressive Floating CTA - Purple & Gold
export const AggressiveFloatingCTA = () => {
 const scrollToForm = () => {
 if (typeof window.fbq === 'function') {
 window.fbq('track', 'InitiateCheckout', { content_name: 'Aggressive Floating CTA' });
 }
 const form = document.getElementById('contact-form-section');
 if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 return (
 <>
 {/* Mobile Bottom CTA */}
 <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 sm:hidden">
 <button
 onClick={scrollToForm}
 className="px-6 py-3 font-bold rounded-full flex items-center gap-2" style={{ background: 'linear-gradient(135deg, #6E0F0F, #A31515)', color: '#F5E7C8', border: '1.5px solid #C9A23A', boxShadow: '0 8px 26px rgba(163,21,21,0.5)' }}
 data-testid="mobile-floating-cta"
 >
 ❖ जांच करवाएं - क्षमतानुसार
 </button>
 </div>
 </>
 );
};

// Price Anchoring - Purple & Gold Theme
export const PriceAnchoring = () => {
 const scrollToForm = () => {
 const form = document.getElementById('contact-form-section');
 if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 return (
 <div className="py-16 px-4" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, #101014 50%, #0B0B0E 100%)' }} data-testid="price-anchoring">
 <div className="container mx-auto max-w-3xl text-center">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 जांच क्षमतानुसार दक्षिणा
 </span>
 <h3 className="text-2xl sm:text-3xl font-black text-[#D8D2C6] mb-6" style={{ fontFamily: "'Rozha One', serif" }}>
 माता जी से <span className="">क्षमतानुसार जांच</span> में करवाएं!
 </h3>
 
 <div className="p-8 rounded-2xl bg-gradient-to-br from-[#17171C] to-[#101014] border border-[#d4a84b]/60 mb-8">
 <div className="flex flex-col items-center gap-4">
 <div className="w-20 h-20 rounded-full bg-[#250808] border border-[#C9A23A]/40 flex items-center justify-center text-4xl">

 </div>
 <div>
 <p className="text-[#F3EDE2] text-sm font-bold">जांच दक्षिणा</p>
 
 <p className="text-[#F3EDE2] text-4xl font-black">क्षमतानुसार!</p>
 <p className="text-[#D8D2C6]/70 text-sm mt-2">श्रद्धानुसार दक्षिणा दें</p>
 </div>
 </div>
 
 <div className="mt-6 flex flex-wrap justify-center gap-3">
 <span className="px-3 py-1 rounded-full text-xs bg-[#0B0B0E] border border-[#d4a84b]/30 text-[#F3EDE2]">क्षमतानुसार दक्षिणा</span>
 <span className="px-3 py-1 rounded-full text-xs bg-[#0B0B0E] border border-[#d4a84b]/30 text-[#F3EDE2]">सीधी बात</span>
 <span className="px-3 py-1 rounded-full text-xs bg-red-700/20 border border-[#d4a84b]/60 text-[#D8D2C6]">फॉर्म से संपर्क</span>
 </div>
 </div>
 
 <button 
 onClick={scrollToForm} 
 className="px-10 py-4 text-xl font-black rounded-full hover:scale-105 transition-all" style={{ background: 'linear-gradient(135deg, #6E0F0F, #A31515)', color: '#F5E7C8', border: '1.5px solid #C9A23A', boxShadow: '0 8px 26px rgba(163,21,21,0.45)', fontFamily: "'Rozha One', serif" }}
 >
 अभी जांच करवाएं - क्षमतानुसार
 </button>
 </div>
 </div>
 );
};

// VideoTestimonialBanner removed — we don't show video testimonials.
